import isVeryNice from '../User/is-very-nice';
import isSuperNice from '../User/is-super-nice';

export default function getPlanColor(plan, theme) {
  if (isVeryNice(plan)) return theme.palette.secondary.main;
  if (isSuperNice(plan)) return theme.palette.accent.main;

  return theme.palette.info.main;
}
